import { EnumSchema } from '../metadata-schema';

export const VsoCluster: EnumSchema = {
	"type": "string",
	"title": "VsoCluster",
	"enum": [
		"Cluster 1",
		"Cluster 2",
		"Cluster 2+EMB",
		"Cluster 3",
		"Cluster 3/4",
		"Cluster 4"
	]
};
